import { ValidationError } from "sequelize"
import {
    MtStudySession,
    MtStudySessionCreate,
    MtStudySessionSave,
    MtStudySessionAttendance,
} from "server/models"
import { OrderType } from "client/utils"
import {
    GET, POST, DELETE, sort, search, validate,
} from "client/store/utils"
import {
    LangType,
    StudySessionList,
    StudySessionValidation,
    StudySessionFilters,
    StudySessionAttendance,
} from "client/store"

// sessions

export const LoadAllStudySessions = (projectId: number) => (
    GET(`/mtStudySession/projectId/${projectId}`)
    .then((sessions: MtStudySession[]) => {
        const sessionList: StudySessionList = {}
        sessions.forEach((session) => {
            sessionList[session.id] = session
        })
        return sessionList
    })
)

export const LoadStudySessionById = (sessionId: number, projectId: number) => (
    GET(`/mtStudySession/id/${sessionId}/projectId/${projectId}`)
    .then((session: MtStudySession) => session)
)

export const SaveStudySession = (
    id: number,
    studySession: MtStudySessionCreate,
    lang: LangType,
) => {
    const data: MtStudySessionSave = {
        id,
        studySession,
    }
    return POST(
        "/mtStudySession/save",
        JSON.stringify(data),
    ).then((res) => {
        const newSession = res as MtStudySession
        const error = res as ValidationError

        return {
            newSessionId: newSession.id || null,
            validation: <StudySessionValidation>validate(error, lang),
        }
    })
}

export const DeleteStudySession = (sessionId: number, projectId: number) => (
    DELETE(`/mtStudySession/delete/${sessionId}/${projectId}`)
    .then((removedRows: number) => removedRows)
)

export const SortStudySessions = (
    sessions: MtStudySession[],
    sortColumn: keyof MtStudySession,
    sortOrder: OrderType,
    filters: StudySessionFilters,
): number[] => {
    const sessionsFiltered = sessions.filter((session) => {
        let showRow = true
        if (filters.search) showRow = search(filters.search, session)
        return showRow
    })

    const sessionIds: number[] = []
    sessionsFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))
    sessionsFiltered.forEach((session) => sessionIds.push(session.id))

    return sessionIds
}

// attendance

export const LoadAllStudySessionAttendance = (projectId: number) => (
    GET(`/mtStudySessionAttendance/projectId/${projectId}`)
    .then((rows: MtStudySessionAttendance[]) => {
        const sessionAttendance: StudySessionAttendance = {}
        rows.forEach((row) => {
            if (!sessionAttendance[row.sessionId]) sessionAttendance[row.sessionId] = {}
            sessionAttendance[row.sessionId][row.teamMemberId] = row.attendance
        })
        return sessionAttendance
    })
)
export const SaveStudySessionAttendance = (data: MtStudySessionAttendance[]) => (
    POST(
        "/mtStudySessionAttendance/save",
        JSON.stringify(data),
    )
)
